import _Model from "./_Model";
import Device from "./Device";

export default class DeviceWithQuantity extends _Model {
  constructor(json) {
    super(json);
    this.device = DeviceWithQuantity.getMappedOrDefault(json, 'device', null, d => new Device(d));
    this.imageLink = DeviceWithQuantity.getOrDefault(json, 'imageLink', this.device?.id);
    this.quantity = DeviceWithQuantity.getOrDefault(json, 'quantity', 1);
    this.id = this.device?.id;
  }
}
